if (!customElements.get('lunatre-product-inquiry')) {
  class LunatreProductInquiry extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      if (!this.dialog || !this.form) return;
      this.variants = JSON.parse(this.querySelector('[data-inquiry-variants]').textContent);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-inquiry-open]');
        if (opener) this.open(opener);
        if (event.target.closest('[data-inquiry-close]')) this.dialog.close();
      }, options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restorePage(), options);
      this.dialog.addEventListener('pointerdown', (event) => {
        this.backdropStart = this.isBackdrop(event);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.backdropStart && this.isBackdrop(event)) this.dialog.close();
        this.backdropStart = false;
      }, options);
      document.addEventListener('variant:update', (event) => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        this.selectedVariantId = String(event.detail?.resource?.id || '');
        this.syncProduct();
      }, options);
      this.form.addEventListener('submit', () => this.syncProduct(), options);
      const result = this.querySelector('[data-inquiry-result]');
      if (result?.dataset.inquiryResult === 'success') {
        this.prepend(result);
        this.querySelector('.lni-invitation').hidden = true;
        const url = new URL(location.href);
        url.searchParams.delete('contact_posted');
        url.hash = result.id;
        history.replaceState(history.state, '', url);
        result.focus({ preventScroll: true });
        result.scrollIntoView({ block: 'center', behavior: 'instant' });
      } else if (result && location.hash === '#' + this.form.id) {
        this.open(null);
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.restorePage();
    }

    isBackdrop(event) {
      if (event.target !== this.dialog) return false;
      const box = this.dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    }

    syncProduct() {
      const url = new URL(location.href);
      const page = this.closest('.shopify-section') || document;
      const configuredSize = page.querySelector('#elegc-sumsize')?.textContent.trim();
      const configuredVariant = configuredSize && this.variants.find((item) => item.title === configuredSize);
      const urlVariant = this.variants.find((item) => item.id === url.searchParams.get('variant'));
      const eventVariant = this.variants.find((item) => item.id === this.selectedVariantId);
      const formVariantId = page.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const formVariant = this.variants.find((item) => item.id === formVariantId);
      const variant = configuredVariant || urlVariant || eventVariant || formVariant || this.variants.find((item) => item.id === this.dataset.defaultVariant) || this.variants[0];
      if (!variant) return;
      this.querySelector('[data-inquiry-variant]').textContent = variant.title === 'Default Title' ? '' : variant.title;
      const setValue = (selector, value) => {
        const field = this.querySelector(selector);
        if (field) field.value = value || '';
      };
      setValue('[data-inquiry-variant-input]', variant.title);
      setValue('[data-inquiry-variant-id]', variant.id);
      setValue('[data-inquiry-sku]', variant.sku);
      const configuration = ['#elegc-sumfab', '#elegc-sumsockel'].map((selector) => page.querySelector(selector)?.textContent.trim()).filter(Boolean).join(' · ');
      const configLabel = this.querySelector('[data-inquiry-configuration]');
      configLabel.textContent = configuration;
      configLabel.hidden = !configuration;
      const configField = this.querySelector('[data-inquiry-configuration-input]');
      if (configField) {
        configField.value = configuration;
        configField.disabled = !configuration;
      }
      url.searchParams.set('variant', variant.id);
      url.searchParams.set('contact_posted', 'true');
      url.hash = this.form.id;
      setValue('[name="return_to"]', url.pathname + url.search + url.hash);
      const productUrl = new URL(url.pathname, url.origin);
      productUrl.searchParams.set('variant', variant.id);
      for (const key of ['stoff', 'sockel', 'groesse']) {
        if (url.searchParams.has(key)) productUrl.searchParams.set(key, url.searchParams.get(key));
      }
      setValue('[data-inquiry-product-url]', productUrl.href);
    }

    open(opener) {
      if (this.dialog.open) return;
      this.opener = opener || this.querySelector('[data-inquiry-open]');
      this.syncProduct();
      const topic = this.querySelector('[data-inquiry-topic]');
      if (topic && opener && this.lastMode !== opener.dataset.inquiryOpen) {
        const option = topic.querySelector('[data-topic="' + opener.dataset.inquiryOpen + '"]');
        if (option) topic.value = option.value;
        this.lastMode = opener.dataset.inquiryOpen;
      }
      this.lockPage();
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
      (this.querySelector('[data-inquiry-result]') || this.querySelector('[data-inquiry-title]')).focus({ preventScroll: true });
    }

    lockPage() {
      const body = document.body;
      const properties = ['position', 'top', 'left', 'right', 'width', 'padding-right'];
      this.pageState = {
        x: window.scrollX,
        y: window.scrollY,
        body: properties.map((key) => [key, body.style.getPropertyValue(key), body.style.getPropertyPriority(key)]),
        overflow: document.documentElement.style.getPropertyValue('overflow'),
        overflowPriority: document.documentElement.style.getPropertyPriority('overflow')
      };
      const gutter = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
      body.style.setProperty('position', 'fixed');
      body.style.setProperty('top', -this.pageState.y + 'px');
      body.style.setProperty('left', -this.pageState.x + 'px');
      body.style.setProperty('right', '0');
      body.style.setProperty('width', '100%');
      if (gutter) body.style.setProperty('padding-right', padding + gutter + 'px');
      document.documentElement.style.setProperty('overflow', 'hidden');
    }

    restorePage() {
      if (!this.pageState) return;
      const state = this.pageState;
      this.pageState = null;
      for (const [key, value, priority] of state.body) {
        if (value) document.body.style.setProperty(key, value, priority);
        else document.body.style.removeProperty(key);
      }
      if (state.overflow) document.documentElement.style.setProperty('overflow', state.overflow, state.overflowPriority);
      else document.documentElement.style.removeProperty('overflow');
      window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }
  }
  customElements.define('lunatre-product-inquiry', LunatreProductInquiry);
}
